module.exports = __webpack_public_path__ + "img/next_inactive.c9e6dfbb.png";